export enum ShippingProvider {
    FEDEX = 'FedEx',
    DHL = 'DHL',
    WANBEXPRESS = 'WanbExpress',
    YUNEXPRESS = 'YunExpress',
    CMA_CGM = 'CMA CGM',
    MAERSK = 'Maersk',
    UPS = 'UPS',
    FEMAG_TRANSPORT = 'Femag Transport',
    FLEXPORT = 'Flexport',
    ZIM = 'ZIM',
    MSC = 'MSC',
    DPD = 'DPD',
    POLAR = 'Polar',
    OTHER = 'Other',
}
